export class VALIDATE {
    static ERRORS_EXISTS = 'errors_exists';
    static MISSING_XY_OR_CITY_STREET = 'missing_xy_or_city_street';
    static BOTH_CITY_STREET_SHOULD_BE_SELECTED = 'both_city_street_should_be_selected';
    static Y_SHOULD_BE_SELECTED_IF_X_IS_SELECTED = 'y_should_be_selected_if_x_is_selected';
    static X_SHOULD_BE_SELECTED_IF_Y_IS_SELECTED = 'x_should_be_selected_if_y_is_selected';
}
